import React, { ComponentType, memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './BaseSelect.module.less'

export interface IInputTextProps {
  Icon?: ComponentType<ISvgIconProps>
  children?: ReactNode
  className?: string
  isDisabled?: boolean
  testId?: string
}

export const InputText = memo<IInputTextProps>(function InputText({
  className,
  isDisabled = false,
  Icon,
  children = '',
  testId = ''
}) {
  return (
    <>
      {Icon && <Icon className={cn(s.icon, s.icon_beforeInput)} size="nm" />}
      <p
        data-test-id={testId}
        className={cn(
          s.selectText,
          { [s.selectText_icon]: Boolean(Icon) },
          { [s.selectText_disabled]: isDisabled },
          className
        )}
      >
        {children}
      </p>
    </>
  )
})
